export default {
  methods: {
    getRandomKey(min, max) {
      const min1 = Math.ceil(min);
      const max1 = Math.floor(max);
      return Math.floor(Math.random() * (max1 - min1 + 1)) + min1;
    },
  },
};
